import React, {useState, useEffect} from "react";
import { Link, useParams } from "react-router-dom";

import Tagline from "../../../components/tagline";
import Navbar from "../../../components/navbar";
import ProductDetail from "../../../components/product-detail";
import ProductAboutTab from "../../../components/product-about-tab";
import ArrivalItem from "../../../components/arrival-item";
import Footer from "../../../components/footer";
import Switcher from "../../../components/switcher";
import ScrollToTop from "../../../components/scroll-to-top";

import TinySlider from "tiny-slider-react";
import "tiny-slider/dist/tiny-slider.css";
import { useGetProductsQuery } from "../../../redux/services/products";
import Loader from "../../../components/Loader";
import { useGetAllProductPropertiesQuery } from "../../../redux/services/product_properties";

export default function ProductDetailThree() {
  let { id } = useParams();
  const settings = {
    container: ".tiny-single-item",
    items: 1,
    controls: false,
    mouseDrag: true,
    loop: true,
    rewind: true,
    autoplay: true,
    autoplayButtonOutput: false,
    autoplayTimeout: 3000,
    navPosition: "bottom",
    speed: 400,
    gutter: 16,
  };
  const {
    data: product,
    error,
    isFetching: isLoading,
  } = useGetProductsQuery({ filter: { id: id } });
  const { data: allProperties } = useGetAllProductPropertiesQuery();

  const [properties, setProperties] = useState([{ name: "", value: "" }]);

  useEffect(() => {
    if (allProperties) {
      const productProperties = allProperties.filter(
        (prop) => prop.product_id === id
      );

      if (productProperties.length > 0) {
        // Mapping the properties from the API response
        const newProperties = productProperties.map((property) => ({
          name: property.name,
          value: property.value,
        }));
        setProperties(newProperties);
      }
    }
  }, [allProperties, id]);

  return (
    <>
      {/* <Tagline /> */}
      <Navbar navClass="defaultscroll is-sticky tagline-height" />
      {isLoading ? (
        <Loader />
      ) : product?.length ? (
        <>
          <section className="relative table w-full py-20 lg:py-24 md:pt-28 bg-gray-50 dark:bg-slate-800">
            <div className="container relative">
              <div className="grid grid-cols-1 mt-14">
                <h3 className="text-3xl leading-normal font-semibold">
                  {product[0].title}
                </h3>
              </div>

              <div className="relative mt-3">
                <ul className="tracking-[0.5px] mb-0 inline-block">
                  <li className="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out hover:text-orange-500">
                    <Link to="/">TAS e store</Link>
                  </li>
                  <li className="inline-block text-base text-slate-950 dark:text-white mx-0.5 ltr:rotate-0 rtl:rotate-180">
                    <i className="mdi mdi-chevron-right"></i>
                  </li>
                  <li className="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out hover:text-orange-500">
                    <Link to="/shop-grid">Store</Link>
                  </li>
                  <li className="inline-block text-base text-slate-950 dark:text-white mx-0.5 ltr:rotate-0 rtl:rotate-180">
                    <i className="mdi mdi-chevron-right"></i>
                  </li>
                  <li
                    className="inline-block uppercase text-[13px] font-bold text-orange-500"
                    aria-current="page"
                  >
                    {product[0].title}
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section className="relative md:py-24 py-16">
            <div className="container relative">
              <div className="grid lg:grid-cols-12 md:grid-cols-2 grid-cols-1 gap-6 items-center">
                <div className="lg:col-span-5">
                  <div className="tiny-single-item">
                    <TinySlider settings={settings}>
                      {product[0]?.image_urls?.length &&
                        product[0]?.image_urls?.map((item, index) => {
                          return (
                            <div className="tiny-slide" key={index}>
                              <div className="m-0.5">
                                <img
                                  src={item}
                                  className="shadow dark:shadow-gray-700"
                                  alt=""
                                />
                              </div>
                            </div>
                          );
                        })}
                    </TinySlider>
                  </div>
                </div>
                <div className="lg:col-span-7">
                  <ProductDetail data={product[0]} />
                </div>
              </div>

              <ProductAboutTab
                data={product[0]}
                productProperties={properties}
              />
            </div>

            <ArrivalItem />
          </section>
        </>
      ) : error ? (
        <div>{error?.message}</div>
      ) : (
        <div className=" h-1">No Data Found</div>
      )}
      <Footer />
      {/* <Switcher /> */}
      <ScrollToTop />
    </>
  );
}
